import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-skip-forward",
  "use": "icon-skip-forward-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-skip-forward\" id=\"icon-skip-forward\"><polygon points=\"5 4 15 12 5 20 5 4\" /><line x1=\"19\" y1=\"5\" x2=\"19\" y2=\"19\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol